import { inject, provide } from 'vue';

type CreateContextReturn<T> = [(opts: T) => void, (fallback?: T) => T, symbol]

export function createContext<T>(id: string) {
  const contextId = Symbol(id);

  function consumer(fallback?: T) {
    return inject(contextId, fallback);
  }

  function provider(value: T) {
    return provide(contextId, value);
  }

  return [provider, consumer, contextId] as CreateContextReturn<T>;
}
